<div class="card admin-card">
   <div
      class="card-head"
      style="margin-bottom: 35px">
      <div>
         <div class="card-title">Role &amp; Permission Management</div>
         <div style="font-size: 13px; color: var(--muted); margin-top: 2px">
            Control admin access levels — differentiate standard admins from super admins and manage app-specific permissions.
         </div>
      </div>
   </div>

   <div
      class="loading"
      *ngIf="loading">
      Loading admin users…
   </div>

   <ng-container *ngIf="!loading">
      <div class="um-rp-grid">
         <div>
            <div class="um-rp-col-title">Admin users</div>

            <div class="rp-admin-tbl-wrap">
               <table class="admin-tbl rp-admin-tbl">
                  <thead>
                     <tr>
                        <th>Name</th>
                        <th>Access Level</th>
                        <th></th>
                     </tr>
                  </thead>
                  <tbody>
                     <tr *ngFor="let admin of adminUsers">
                        <td>
                           <div class="name-cell">
                              <div
                                 class="av"
                                 [style.background]="getAvatarBg(admin.displayName)"
                                 [style.color]="getAvatarColor(admin.displayName)">
                                 {{ getInitials(admin.displayName) }}
                              </div>
                              {{ admin.displayName }}
                           </div>
                        </td>
                        <td>
                           <span
                              class="um-access-badge"
                              [class.badge-super]="admin.accessLevel === 'SuperAdmin'"
                              [class.badge-standard]="admin.accessLevel === 'StandardAdmin'">
                              {{ admin.accessLevel === "SuperAdmin" ? "Super Admin" : "Standard Admin" }}
                           </span>
                        </td>
                        <td>
                           <button
                              class="v-button v-button-sm v-gray"
                              (click)="openEditAdmin(admin)">
                              Edit
                           </button>
                        </td>
                     </tr>
                     <tr *ngIf="adminUsers.length === 0">
                        <td
                           colspan="3"
                           class="muted"
                           style="padding: 20px; text-align: center">
                           No admin users found.
                        </td>
                     </tr>
                  </tbody>
               </table>
            </div>

            <button
               class="v-button v-button-md v-teal"
               style="margin-top: 40px; margin-bottom: 10px"
               (click)="openAddAdmin()">
               + Add admin
            </button>

            <div
               class="admin-success"
               *ngIf="actionSuccess">
               {{ actionSuccess }}
            </div>
            <div
               class="admin-error"
               *ngIf="actionError">
               {{ actionError }}
            </div>
         </div>

         <div>
            <div
               class="um-rp-col-title"
               style="padding-left: 5px">
               Permission matrix
            </div>
            <div class="um-permission-matrix">
               <div
                  class="um-perm-row"
                  *ngFor="let p of permissionMatrix">
                  <span class="um-perm-label">{{ p.label }}</span>
                  <span
                     class="um-perm-access"
                     [class.access-both]="p.level === 'both'"
                     [class.access-super]="p.level === 'super'">
                     {{ p.level === "both" ? "Standard + Super" : "Super only" }}
                  </span>
               </div>
            </div>
            <div style="font-size: 12px; color: var(--muted); margin-top: 12px; line-height: 1.6; padding-left: 5px">
               Super admins have all Standard admin permissions, plus the ability to transfer users between locations, perform high-level overrides,
               control deferral requests, manage cycles and assign administrators.
            </div>
         </div>
      </div>
   </ng-container>
</div>

<!-- Add / Edit admin modal -->
<div
   class="um-dialog-backdrop"
   *ngIf="editDialogAdmin"
   (click)="closeEditAdmin()"></div>

<div
   class="um-dialog rp-modal"
   *ngIf="editDialogAdmin">
   <div class="rp-modal-header">
      <div class="rp-modal-title">
         {{ editDialogAdmin.id ? "Edit admin user" : "Add admin user" }}
      </div>
      <button
         class="rp-modal-close"
         (click)="closeEditAdmin()"
         title="Close">
         ✕
      </button>
   </div>

   <div class="rp-modal-body">
      <ng-container *ngIf="!editDialogAdmin.id">
         <div class="rp-field">
            <label class="rp-label">USER</label>
            <div class="rp-autocomplete-wrap">
               <input
                  class="rp-input"
                  [(ngModel)]="userSearchQuery"
                  (input)="onUserSearchInput()"
                  (focus)="onUserSearchInput()"
                  (blur)="onSearchBlur()"
                  placeholder="Search for a user…"
                  autocomplete="off" />

               <button
                  *ngIf="selectedUserForAdmin"
                  class="rp-input-clear"
                  (click)="clearSelectedUser()"
                  title="Clear"
                  style="margin-top: 22px">
                  ✕
               </button>

               <div
                  class="rp-selected-pill"
                  *ngIf="selectedUserForAdmin">
                  <div
                     class="av av-sm"
                     [style.background]="getAvatarBg(selectedUserForAdmin.displayName)"
                     [style.color]="getAvatarColor(selectedUserForAdmin.displayName)">
                     {{ getInitials(selectedUserForAdmin.displayName) }}
                  </div>
                  <span>{{ selectedUserForAdmin.displayName }}</span>
               </div>

               <div
                  class="rp-autocomplete-dropdown"
                  *ngIf="showUserDropdown && userSearchResults.length > 0">
                  <div
                     class="rp-autocomplete-item"
                     *ngFor="let u of userSearchResults"
                     (mousedown)="selectUserForAdmin(u)">
                     <div
                        class="av av-sm"
                        [style.background]="getAvatarBg(u.displayName)"
                        [style.color]="getAvatarColor(u.displayName)">
                        {{ getInitials(u.displayName) }}
                     </div>
                     <div class="rp-autocomplete-item-text">
                        <div class="rp-autocomplete-name">{{ u.displayName }}</div>
                     </div>
                  </div>
               </div>

               <div
                  class="rp-autocomplete-dropdown rp-autocomplete-empty"
                  *ngIf="searchLoading">
                  Searching…
               </div>

               <div
                  class="rp-autocomplete-dropdown rp-autocomplete-empty"
                  *ngIf="showUserDropdown && userSearchQuery.length >= 2 && userSearchResults.length === 0">
                  No users found matching "{{ userSearchQuery }}"
               </div>
            </div>
         </div>
      </ng-container>

      <ng-container *ngIf="editDialogAdmin.id">
         <div class="rp-field">
            <label class="rp-label">USER</label>
            <div
               class="name-cell"
               style="margin-top: 6px">
               <div
                  class="av"
                  [style.background]="getAvatarBg(editDialogAdmin.displayName)"
                  [style.color]="getAvatarColor(editDialogAdmin.displayName)">
                  {{ getInitials(editDialogAdmin.displayName) }}
               </div>
               <span style="font-weight: 600; font-size: 14px">{{ editDialogAdmin.displayName }}</span>
            </div>
         </div>
      </ng-container>

      <div
         class="rp-field"
         style="margin-top: 30px">
         <label class="rp-label">ACCESS LEVEL</label>
         <div class="rp-access-options">
            <div
               class="rp-access-option"
               [class.selected]="editDialogAdmin.accessLevel === 'StandardAdmin'"
               (click)="editDialogAdmin.accessLevel = 'StandardAdmin'">
               <div class="rp-access-option-header">
                  <span class="rp-access-option-title">Standard Admin</span>
                  <div
                     class="rp-radio"
                     [class.checked]="editDialogAdmin.accessLevel === 'StandardAdmin'"></div>
               </div>
               <div class="rp-access-option-desc">View reviews, manage review statuses, view analytics & export data.</div>
            </div>
            <div
               class="rp-access-option"
               [class.selected]="editDialogAdmin.accessLevel === 'SuperAdmin'"
               (click)="editDialogAdmin.accessLevel = 'SuperAdmin'">
               <div class="rp-access-option-header">
                  <span class="rp-access-option-title">Super Admin</span>
                  <div
                     class="rp-radio"
                     [class.checked]="editDialogAdmin.accessLevel === 'SuperAdmin'"></div>
               </div>
               <div class="rp-access-option-desc">
                  All Standard permissions plus transfer users, high-level overrides, control deferral requests, manage cycles & assign
                  administrators.
               </div>
            </div>
         </div>
      </div>
   </div>

   <div class="rp-modal-footer">
      <a
         href="javascript:void(0);"
         *ngIf="editDialogAdmin.id"
         style="margin-right: auto; font-weight: 600; letter-spacing: 0.5px; color: #04534a; font-size: 12px; text-decoration: underline"
         (click)="removeAdmin(editDialogAdmin)">
         Remove admin
      </a>
      <button
         class="v-button v-button-md v-gray"
         (click)="closeEditAdmin()">
         Cancel
      </button>
      <button
         class="v-button v-button-md v-teal"
         [disabled]="dialogSaving || (!editDialogAdmin.id && !selectedUserForAdmin)"
         (click)="saveAdmin()">
         {{ dialogSaving ? "Saving…" : "Save" }}
      </button>
   </div>
</div>
